import {
    RecaptchaVerifier,
    sendSignInLinkToEmail,
    isSignInWithEmailLink,
    signInWithEmailLink,
    //signInWithPhoneNumber,
    linkWithPhoneNumber,
    ConfirmationResult,
    signInWithCustomToken,
    createUserWithEmailAndPassword, //deprecated
    signInWithEmailAndPassword, //deprecated
    signOut,
    onAuthStateChanged,
    User,
    EmailAuthProvider,
    reauthenticateWithCredential,
    verifyBeforeUpdateEmail,
    updatePhoneNumber,
    PhoneAuthProvider,
    unlink,
    onIdTokenChanged
} from "firebase/auth";
import {
    collection,
    getDocs,
    doc,
    getDoc,
    updateDoc,
    setDoc,
    count,
    arrayUnion,
    getCountFromServer
} from "firebase/firestore";
import { auth, fs, functions, messaging } from "../firebase.ts";
import { httpsCallable } from "firebase/functions";
import {
    startRegistration,
    startAuthentication,
    browserSupportsWebAuthn
} from "@simplewebauthn/browser";
import { getToken } from "firebase/messaging";

import {
    isProduction,
    isPwa,
    isPopup,
    ADMINS,
    MONKS,
    getLanguage,
    BANKERS
} from "../components/global.ts";

import Strings from "../models/Strings.json";
const strings: any = Strings;
const WAIT = isPopup ? " PLEASE WAIT..." : "";
const swURL = new URL("../sw.js", import.meta.url);

interface UserProfile {
    email: string | null;
    //emailVerified: boolean; // always true bc email link signup/login
    displayName: string | null;
    photoURL: string | null;
    phoneNumber: string | null;
    //username: string | null;
    // You could add custom fields here that are managed by functions, like 'role'
    // role?: string;
}

// Define the response type from the Cloud Function
interface TokenResponse {
    token: string;
    timestamp: string;
    uid: string;
}

interface CodeResponse {
    code: string;
    timestamp: string;
    uid: string;
}

type Status = {
    text: string;
    color: "green" | "red" | "orange";
    user?: User | null;
    token?: string | null;
    code?: string | null;
};

// use: default firebase auth data
export class HeartBank {
    private recaptchaVerifier: RecaptchaVerifier | null = null;
    private confirmationResult: ConfirmationResult | null = null;
    private verificationId: string | null = null;
    user: User | null = null; //auth.currentUser; // always fresh?? no, but maybe need to try another way; refactor code below: remove updating this.user

    constructor() {
        onAuthStateChanged(auth, (user) => (this.user = user));

        // may be cheaper to do in account.ts as user profile is updated there
        onIdTokenChanged(auth, async (user: User | null) => {
            if (!user) {
                // User is signed out. No action needed here.
                //console.log("Auth state: User is signed out.");
                return;
            }

            // User is signed in or their token was refreshed.
            const userDocRef = doc(fs, "users", user.uid);

            try {
                const userDocSnap = await getDoc(userDocRef);

                // Construct the profile object from the current Auth user state
                const authProfile: UserProfile = {
                    email: user.email,
                    //emailVerified: user.emailVerified,
                    displayName: user.displayName,
                    photoURL: user.photoURL,
                    phoneNumber: user.phoneNumber // duplicate but important bc verified
                    //username: null
                };

                if (!userDocSnap.exists()) {
                    // This case can happen if the onUserCreated function is slow or fails.
                    // This listener provides a good fallback to create the document if it's missing.
                    console.warn(
                        `Firestore document for user ${user.uid} not found. Creating it now.`
                    );
                    await setDoc(
                        userDocRef,
                        {
                            createdAt: new Date(),
                            ...authProfile
                        },
                        { merge: true } // in case sometimes weird bug: erase!
                    );
                    return;
                }

                // const firestoreProfile = userDocSnap.data() as UserProfile;
                // const updates: Partial<UserProfile> = {};

                // // Compare each field and build an `updates` object.
                // // This is more efficient than writing all fields every time.
                // if (firestoreProfile.email !== authProfile.email)
                //     updates.email = authProfile.email;
                // // if (
                // //     firestoreProfile.emailVerified !== authProfile.emailVerified
                // // )
                // //     updates.emailVerified = authProfile.emailVerified;
                // if (firestoreProfile.displayName !== authProfile.displayName)
                //     updates.displayName = authProfile.displayName;
                // if (firestoreProfile.photoURL !== authProfile.photoURL)
                //     updates.photoURL = authProfile.photoURL;
                // if (firestoreProfile.phoneNumber !== authProfile.phoneNumber)
                //     updates.phoneNumber = authProfile.phoneNumber;

                // // Only perform a write if there are actual changes.
                // if (Object.keys(updates).length > 0) {
                //     // console.log(
                //     //     "Auth data is out of sync with Firestore. Applying updates:",
                //     //     updates
                //     // );
                //     //if (isProduction) {
                //     await updateDoc(userDocRef, updates); //TODO: weird loading firestore emulator slow
                //     console.log("Firestore document synced successfully.");
                //     //}
                //     // TODO: should i do this to enable 1 read instead of 2 reads ?
                //     // will need to add user's changing public key too and user's scores etc!
                //     // from public key to user data requires 2 reads as well; should i do this for 1 read as well ?
                //     // for now, prob no for both bc too much work sync'ing data!
                //     // if (firestoreProfile.username) {
                //     //     const usernameDocRef = doc(
                //     //         fs,
                //     //         "usernames",
                //     //         firestoreProfile.username
                //     //     );
                //     //     await updateDoc(usernameDocRef, updates); // hide email and phone number to protect user's privacy ??
                //     // }
                // } else {
                //     // This will be the most common case on hourly token refreshes.
                //     //console.log("Auth and Firestore data are in sync.");
                // }
            } catch (error) {
                console.error("Error syncing user data to Firestore:", error);
            }
        });
    }

    public async saveTokenToFirestore() {
        try {
            const permission = await Notification.requestPermission();
            if (permission !== "granted") {
                alert(
                    "Please add this app to your Home Screen and allow Push Notifications to receive an alert whenever someone nearby thanks you!"
                );
                return;
            }

            const registration = await navigator.serviceWorker.register(swURL);

            const currentToken = await getToken(messaging, {
                vapidKey:
                    "BNuEXHVA_ROIoh-e_sErqz-EDL2k4K1Yxhp7ge6UeH2HFqlhKyXx7M2BJZX3H5Y7QGK7E7NuuxsWmweYJPEVdGw",
                serviceWorkerRegistration: registration
            });

            if (currentToken && this.user) {
                const userRef = doc(fs, "users", this.user.uid);

                // Add token to an array so we don't overwrite other devices
                await setDoc(
                    userRef,
                    {
                        fcmTokens: [currentToken] // arrayUnion(currentToken)
                        //lastUpdated: new Date() // auto converted to Firestore Timestamp // pro not needed
                    },
                    { merge: true }
                );

                console.log("Token saved to Firestore successfully");
            }
        } catch (error) {
            console.error("Error saving token:", error);
        }
    }

    isAdmin(): boolean {
        if (!this.user) return false;
        return !!(this.user?.email && ADMINS.includes(this.user.email));
    }

    // not used
    isAdmin2(): boolean {
        if (!this.user) return false;
        return isProduction
            ? !!(this.user?.email && ADMINS.includes(this.user.email))
            : this.user !== null;
    }

    // for pool rewarding
    isMissAquarius(): boolean {
        if (!this.user) return false;
        return !!(this.user?.email && ADMINS.includes(this.user.email));
    }

    // for family banking: deposit + withdraw
    isBanker(): boolean {
        if (!this.user) return false;
        return !!(this.user?.email && BANKERS.includes(this.user.email));
    }

    // for printing b-stamps
    isMonk(): boolean {
        if (!this.user) return false;
        return isProduction
            ? !!(this.user?.email && MONKS.includes(this.user.email))
            : this.user !== null;
    }

    addAuthStateListener(callback: (user: User | null) => void) {
        return onAuthStateChanged(auth, callback);
    }

    // may need to wait for hero too??
    waitForAuth(): Promise<User | null> {
        return new Promise((resolve) => {
            const unsubscribe = onAuthStateChanged(
                auth,
                (user: User | null) => {
                    unsubscribe(); // Remove the listener after the first call
                    resolve(user); // Resolve with the user (or null if not signed in)
                }
            );
        });
    }

    // this prevents text abuse!
    private setupRecaptcha() {
        const recaptcha2 = document.getElementById("recaptcha");
        if (recaptcha2) {
            recaptcha2.remove();
        }

        const recaptcha = document.createElement("div");
        recaptcha.id = "recaptcha";
        document.body.appendChild(recaptcha);

        try {
            this.recaptchaVerifier = new RecaptchaVerifier(auth, "recaptcha", {
                size: "invisible",
                callback: () => {
                    console.log("reCAPTCHA solved");
                },
                "expired-callback": () => {
                    console.log("reCAPTCHA expired");
                }
            });
            //console.log("reCAPTCHA initialized");
        } catch (error: any) {
            console.error("reCAPTCHA setup error:", error.message);
        }
    }

    // login with email link

    async handleSendEmailLink(
        email: string,
        newEmail: string | null = null
    ): Promise<Status> {
        try {
            // this.setupRecaptcha();
            // if (!this.recaptchaVerifier)
            //     throw new Error("Sorry, bots are not allowed.");

            const url = new URL(window.location.href);
            if (newEmail) {
                url.hash = "#/login/update";
                localStorage.setItem("emailForUpdate", newEmail);
            } else {
                url.hash = "#/login/signin";
                localStorage.setItem("emailForLogin", email); // for security in case user spoof the email link url
            }

            const lang = getLanguage();
            if (lang === "km") {
                const sendLoginLink = httpsCallable<
                    { email: string; url: string; lang: string },
                    { status: string }
                >(functions, "sendLoginLink");
                const result = await sendLoginLink({
                    email,
                    url: url.toString(),
                    lang
                });
                //console.log(result.data.status);
            } else
                await sendSignInLinkToEmail(auth, email, {
                    url: url.toString(), // Redirect back to this page
                    handleCodeInApp: true // Required for email link auth
                });

            return {
                text: newEmail
                    ? `To make this important change, an email link has been sent to ${email} for re-authentication. Please check your inbox or spam folder.`
                    : `Email link sent to ${email}. Please check your inbox or spam folder, and open the link on this ${
                          isPwa ? "device" : "browser"
                      }.`,
                color: "orange"
            };
        } catch (error: any) {
            //console.error(error.message);
            switch (error.code) {
                case "auth/invalid-email":
                    return {
                        text: "Invalid email format.",
                        color: "red"
                    };
                case "auth/email-already-in-use":
                    return {
                        text: "This email is already registered with another user.",
                        color: "red"
                    };
                default:
                    return {
                        text: `Error sending email link: ${error.message}`,
                        color: "red"
                    };
            }
        }
    }

    async handleEmailLink(): Promise<Status> {
        const url = new URL(window.location.href);
        const fragments = window.location.hash.split("/");
        if (!isSignInWithEmailLink(auth, url.toString()))
            return fragments[2] === "update"
                ? {
                      text: `Waiting for email verification from ${localStorage.getItem(
                          "emailForUpdate"
                      )!}`,
                      color: "orange"
                  }
                : { text: "Invalid email link.", color: "red" };

        try {
            if (fragments[2] === "update") {
                const newEmail = localStorage.getItem("emailForUpdate")!;
                if (newEmail) {
                    const credential = EmailAuthProvider.credentialWithLink(
                        this.user!.email!,
                        url.toString()
                    );
                    await reauthenticateWithCredential(this.user!, credential);
                    url.hash = "#/account/updateSuccess";
                    await verifyBeforeUpdateEmail(this.user!, newEmail, {
                        url: url.toString(),
                        handleCodeInApp: true
                    });
                    return {
                        text: `Verification link was sent to ${newEmail}. Please check your inbox or spam folder.`,
                        color: "orange"
                    };
                } else
                    return {
                        text: `To update your email address, please open the link from the same ${
                            isPwa ? "device" : "browser"
                        } you started with, or login again here and try again.`,
                        color: "red"
                    };
            } else {
                const email = localStorage.getItem("emailForLogin");
                if (email) {
                    const credential = await signInWithEmailLink(
                        auth,
                        email,
                        url.toString()
                    );
                    this.user = credential.user;
                    localStorage.removeItem("emailForLogin"); // Clean up
                    return {
                        text: "You have successfully logged in." + WAIT,
                        color: "green"
                    };
                } else
                    return {
                        text: `Please re-enter your email address for verification.`,
                        color: "orange"
                    };
            }
        } catch (error: any) {
            //console.error(error.message);
            switch (error.code) {
                case "auth/missing-email":
                    return {
                        text: `Need to open email link from same ${
                            isPwa ? "device" : "browser"
                        }.`,
                        color: "red"
                    };
                case "auth/invalid-email":
                    localStorage.removeItem("emailForLogin"); // cross device; old email
                    return {
                        text: "Sorry, please try the link again.",
                        color: "red"
                    };
                case "auth/email-already-in-use":
                    return {
                        text: "This email is already registered with another user.",
                        color: "red"
                    };
                case "auth/invalid-action-code":
                    return {
                        text: `To update your email address, please open the link from the same ${
                            isPwa ? "device" : "browser"
                        } you started with, or login again here and try again.`,
                        color: "red"
                    };
                default:
                    return {
                        text: `Error ${
                            fragments[2] === "update"
                                ? "updating email"
                                : "logging in"
                        }: ${error.message}`,
                        color: "red"
                    };
            }
        }
    }

    // login with passkey

    async passKeysCount(): Promise<number> {
        if (this.user) {
            const passkeysRef = collection(
                fs,
                `users/${this.user.uid}/passkeys`
            );
            // This only charges 1/1000th of a normal read per document (up to certain limits)
            const snapshot = await getCountFromServer(passkeysRef);
            return snapshot.data().count;
        }
        return 0;
    }

    isPasskeySupported(): boolean {
        return browserSupportsWebAuthn();
    }

    async registerPasskey(name: string): Promise<Status> {
        try {
            const passkeysRef = collection(
                fs,
                `users/${this.user!.uid}/passkeys`
            );
            const snapshot = await getDocs(passkeysRef);

            let challenge = null;
            if (!snapshot.empty) {
                const getOpts = httpsCallable(functions, "getActionOptions");
                const options: any = (
                    await getOpts({ action: "passkey/register" })
                ).data;

                //if (!document.hasFocus()) window.focus();
                const assertion = await startAuthentication({
                    optionsJSON: options
                });

                const verify = httpsCallable(functions, "verifyAction");
                const result: any = (
                    await verify({ assertion, action: "passkey/register" })
                ).data;
                challenge = result.challenge;
            }

            const getRegOpts = httpsCallable(
                functions,
                "getRegistrationOptions"
            );
            const options: any = (await getRegOpts({ challenge })).data;

            //if (!document.hasFocus()) window.focus();
            const attestation = await startRegistration({
                optionsJSON: options
            });

            const verifyReg = httpsCallable(functions, "verifyRegistration");
            await verifyReg({
                attestation,
                userAgent: navigator.userAgent,
                name
            });

            return {
                text: "You have successfully registered a passkey for this device!",
                color: "green"
            };
        } catch (error: any) {
            //console.error(error);
            //alert(error); // temp for theresa and marco: prob bc iphone version is old
            switch (error.name) {
                case "NotAllowedError":
                    if (error.message === "The document is not focused.")
                        return {
                            text: "Page focus required. Please try again one more time.",
                            color: "orange"
                        };
                    else
                        return {
                            text:
                                "Passkey registration was cancelled: " +
                                error.message,
                            color: "orange"
                        };
                case "InvalidStateError":
                    return {
                        text: "A passkey has already been registered with this authenticator. If you want to choose another, please try again.",
                        color: "orange"
                    };
                default:
                    return {
                        text: `Error during passkey registration: ${error.message}`,
                        color: "red"
                    };
            }
        }
    }

    async revokePasskey(aid: string): Promise<Status> {
        try {
            const getOpts = httpsCallable(functions, "getActionOptions");
            const options: any = (await getOpts({ action: "passkey/revoke" }))
                .data;
            const assertion = await startAuthentication({
                optionsJSON: options
            });

            const verify = httpsCallable(functions, "verifyAction");
            const result: any = (
                await verify({ assertion, action: "passkey/revoke", aid })
            ).data;

            return {
                text: result.message,
                color: "green"
            };
        } catch (error: any) {
            switch (error.name) {
                case "NotAllowedError":
                    return {
                        text: "Passkey verification was cancelled.",
                        color: "orange"
                    };
                default:
                    return { text: error.message, color: "red" };
            }
        }
    }

    async loginWithPasskey(): Promise<Status> {
        try {
            const getLoginOpts = httpsCallable(functions, "getLoginOptions");
            const options: any = (await getLoginOpts()).data;
            const assertion = await startAuthentication({
                optionsJSON: options
            });

            const verifyLogin = httpsCallable(functions, "verifyLogin");
            const result: any = (await verifyLogin({ assertion })).data;
            const heartbank = await signInWithCustomToken(auth, result.token);
            this.user = heartbank.user; // update user after login

            return {
                text: "You have successfully logged in with your passkey!",
                color: "green"
            };
        } catch (error: any) {
            //console.error(error);
            alert(error); // temp to work out all the weird bugs
            if (error.name === "NotAllowedError") {
                return {
                    text: "Passkey login was cancelled.",
                    color: "orange"
                };
            } else {
                return {
                    text: `Error during passkey login: ${error.message}`,
                    color: "red"
                };
            }
        }
    }

    // login with custom token

    async getCustomToken(): Promise<Status> {
        try {
            // Create callable function with explicit type
            const generateLoginToken = httpsCallable<
                { lang: string }, // becomes data property: auth sent by default
                TokenResponse
            >(functions, "generateLoginToken");

            // Call the Cloud Function
            const lang = getLanguage();
            const result = await generateLoginToken({ lang });
            //console.log("Successfully logged in with token:", result.data);

            return {
                text: "Token generated successfully." + WAIT,
                color: "green",
                token: result.data.token
            };
        } catch (error: any) {
            return {
                text: `Error generating token: ${error.message}`,
                color: "red",
                token: null
            };
        }
    }

    async signOut(): Promise<Status> {
        //await this.waitForAuth(); // already done in hb-treasury.ts
        if (this.user) {
            try {
                await signOut(auth);
                this.user = null; // TODO: keep tracking user ??
                return {
                    text:
                        "You have successfully logged out of HeartBank® Vault." +
                        WAIT,
                    color: "green"
                };
            } catch (error: any) {
                return {
                    text: `Error logging out: ${error.message}`,
                    color: "red"
                };
            }
        } else
            return {
                text:
                    "You have successfully logged out of HeartBank® Vault." +
                    WAIT,
                color: "green"
            };
    }

    // account management: add phone number

    async handleSendCode(
        phoneNumber: string,
        resend: boolean = false,
        update: boolean = false
    ): Promise<Status> {
        try {
            this.setupRecaptcha();
            //this.recaptchaVerifier = await this.setupRecaptcha2();

            if (update) {
                const phoneProvider = new PhoneAuthProvider(auth);
                this.verificationId = await phoneProvider.verifyPhoneNumber(
                    phoneNumber,
                    this.recaptchaVerifier!
                );
            } else {
                this.confirmationResult = await linkWithPhoneNumber(
                    this.user!,
                    phoneNumber,
                    this.recaptchaVerifier!
                );
                // this.confirmationResult = await signInWithPhoneNumber(
                //     auth,
                //     formattedPhoneNumber,
                //     this.recaptchaVerifier!
                // );
            }

            return {
                text: resend
                    ? "Code resent successfully!"
                    : "Code sent! Please check your phone.",
                color: "green"
            };
        } catch (error: any) {
            console.error(error.message);
            switch (error.code) {
                case "auth/invalid-phone":
                    return {
                        text: "Invalid phone number format.",
                        color: "red"
                    };
                case "auth/provider-already-linked":
                    return {
                        text: "This phone number is already linked to another account.",
                        color: "red"
                    };
                default:
                    return {
                        text: `Error during send code: ${error.message}`,
                        color: "red"
                    };
            }
        }
    }

    async handleVerifyCode(
        country: string,
        countryCode: string,
        nationalNumber: string,
        code: string,
        update: boolean = false
    ): Promise<Status> {
        try {
            if (update) {
                const credential = PhoneAuthProvider.credential(
                    this.verificationId!,
                    code
                );
                await updatePhoneNumber(this.user!, credential);
                this.user = auth.currentUser; // updated user
            } else {
                const credential = await this.confirmationResult!.confirm(code);
                //this.user = credential.user;
                // linkWithPhoneNumber(
                //     credential.user, //this.user,
                //     this.confirmationResult.verificationId
                // );
                this.user = credential.user;
            }

            //await this.user!.getIdToken(true); // not reliable
            // CHECK: user.phoneNumber = users.phoneNumber = users.countryCode + users.nationalNumber
            const userDocRef = doc(fs, "users", this.user!.uid);
            await updateDoc(userDocRef, {
                country,
                countryCode,
                nationalNumber
            });

            return {
                text: `You have successfully ${
                    update ? "updated" : "added"
                } your phone number!`,
                color: "green",
                user: this.user
            };
        } catch (error: any) {
            switch (error.code) {
                case "auth/invalid-verification-code":
                    return {
                        text: "The code is invalid. Please try again.",
                        color: "red"
                    };
                case "auth/account-exists-with-different-credential":
                    return {
                        text: "This phone number is already linked to another account.",
                        color: "red"
                    };
                default:
                    return {
                        text: `Error verifying code: ${error.message}`,
                        color: "red"
                    };
            }
        }
    }

    async removePhoneNumber(): Promise<Status> {
        try {
            this.user = await unlink(this.user!, "phone");
            return {
                text: "You have successfully removed your phone number.",
                color: "green",
                user: this.user
            };
        } catch (error: any) {
            return {
                text: `Error logging out: ${error.message}`,
                color: "red"
            };
        }
    }

    async updateEmail(email: string): Promise<Status> {
        try {
            //throw new Error("auth/requires-recent-login");
            const url = new URL(window.location.href);
            url.hash = "#/account/updateSuccess";
            await verifyBeforeUpdateEmail(this.user!, email, {
                url: url.toString(),
                handleCodeInApp: true
            });
            return {
                text: `Verification link was sent to ${email}. Please check your inbox or spam folder.`,
                color: "orange"
            };
        } catch (error: any) {
            //console.error(error.message);
            switch (error.code) {
                case "auth/requires-recent-login":
                    return {
                        text: "Recent login required.",
                        color: "red"
                    };
                default:
                    return {
                        text: `Error updating email"
                        }: ${error.message}`,
                        color: "red"
                    };
            }
        }
    }

    // login with email and password
    // use password as 6 digit code to email with letters and special characters

    async sendCode(email: string): Promise<Status> {
        try {
            // Create callable function with explicit type
            const generateLoginCode = httpsCallable<
                { lang: string; email: string },
                CodeResponse
            >(functions, "generateLoginCode");

            // Call the Cloud Function
            const lang = getLanguage();
            const result = await generateLoginCode({ lang, email });

            return {
                text: strings.login6[lang],
                color: "green",
                code: result.data.code
            };
        } catch (error: any) {
            return {
                text: `Error generating code: ${error.message}`,
                color: "red",
                code: null
            };
        }
    }

    async signIn(email: string, password: string): Promise<Status> {
        try {
            const credential = await signInWithEmailAndPassword(
                auth,
                email,
                password
            );
            return {
                text: "You have successfully logged in." + WAIT,
                color: "green",
                user: credential.user
            };
        } catch (error: any) {
            return {
                text: `Error updating signin: ${error.message}`,
                color: "red"
            };
        }
    }

    // not used

    // not allowed: possible loophole // admin cloud function instead
    async signUp(email: string, password: string): Promise<User> {
        try {
            const credential = await createUserWithEmailAndPassword(
                auth,
                email,
                password
            );
            //console.log("User signed up successfully:", credential.user);
            return credential.user;
        } catch (error) {
            //console.error("Error during sign-up:", error);
            throw error;
        }
    }

    // deprecated: don't know why doesn't work...
    private setupRecaptcha2(): Promise<RecaptchaVerifier> {
        return new Promise((resolve, reject) => {
            const recaptcha2 = document.getElementById("recaptcha");
            if (recaptcha2) {
                recaptcha2.remove();
            }

            const recaptcha = document.createElement("div");
            recaptcha.id = "recaptcha";
            document.body.appendChild(recaptcha);

            try {
                const recaptchaVerifier = new RecaptchaVerifier(
                    auth,
                    "recaptcha",
                    {
                        size: "invisible",
                        callback: () => {
                            //console.log("reCAPTCHA solved");
                            resolve(recaptchaVerifier);
                        },
                        "expired-callback": () => {
                            //console.log("reCAPTCHA expired");
                            reject(new Error("reCAPTCHA expired"));
                        }
                    }
                );
            } catch (error: any) {
                //console.error("reCAPTCHA setup error:", error.message);
                reject(error);
            }
        });
    }
}
